import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { botsToolGroupIcon } from './toolGroupIcon';
import { readBotInputSchema } from './botAiToolInputSchemas';

export { readBotInputSchema };

export const readBotOutputSchema = z.object({
  bot: z
    .unknown()
    .nullable()
    .describe(
      'Bot row or null if not found. Validated full shape when `select` is omitted; otherwise matches expanded flat `select` mask.',
    ),
});

export type ReadBotInput = z.infer<typeof readBotInputSchema>;
export type ReadBotOutput = z.infer<typeof readBotOutputSchema>;

export const readBot: AiTool<undefined, ReadBotInput, ReadBotOutput> = {
  id: 'readBot',

  group: 'bots',

  ...botsToolGroupIcon,

  userSelect: false,

  access: 'READ',

  tool: tool({
    description:
      'Load a single bot by id (respects access rules). Omit `select` for the default edit mask; pass a flat `{ fieldName: true }` mask for specific fields. Use `childPrompts: true` to include nested prompts.',
    inputSchema: zodSchema(readBotInputSchema),
    outputSchema: zodSchema(readBotOutputSchema),
  }),
};
